import { jsx, jsxs } from 'react/jsx-runtime';
import { Children, isValidElement, Fragment } from 'react';
import classNames from 'classnames';
import { Divider } from '../../Divider/Divider.es.js';
import { AccordionPanelGroupProvider } from './AccordionPanelGroup.Context/provider.es.js';

const AccordionPanelGroup = ({ size, onCard, children })=>{
    const childrenArray = Children.toArray(children);
    return jsx(AccordionPanelGroupProvider, {
        onCard: onCard,
        size: size,
        children: jsx("div", {
            className: classNames('cb-accordion-panel-group', size, {
                card: onCard
            }),
            children: childrenArray.map((child, index)=>{
                if (!/*#__PURE__*/ isValidElement(child)) return null;
                return jsxs(Fragment, {
                    children: [
                        child,
                        !onCard && index < childrenArray.length - 1 && jsx(Divider, {})
                    ]
                }, child.key ?? index);
            })
        })
    });
};
AccordionPanelGroup.displayName = 'AccordionPanelGroup';

export { AccordionPanelGroup };
//# sourceMappingURL=AccordionPanelGroup.es.js.map
